module.exports = __webpack_public_path__ + "img/35_9.b69e89ee.png";